import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";

// action types
export const ADD_ATTRIBUTE = "addAttribute";
export const GET_ATTRIBUTES = "getAttributes";
export const GET_ATTRIBUTE = "getAttribute";
export const UPDATE_ATTRIBUTE = "updateAttribute";
export const DELETE_ATTRIBUTE = "deleteAttribute";
export const ATTACH_ATTRIBUTE_TO_PRODUCT = "attachAttributeToProduct";
export const UPDATE_ATTRIBUTE_TO_PRODUCT = "updateAttributeToProduct";
export const DETACH_ATTRIBUTE_TO_PRODUCT = "detachAttributeToProduct";
export const SORT_ATTRIBUTE_TO_PRODUCT = "sortAttributeToProduct";


// mutation types
export const SET_ATTRIBUTES_ERROR = "setErrorsAttributes";
export const SET_ATTRIBUTES = "setAttributes";
export const SET_ATTRIBUTE = "setAttribute";
export const SET_ATTRIBUTE_LOAD = "setAttributeLoad";

const state = {
    errors: {},
    attributes: {},
    load: true,
    attribute: {},
};

const getters = {
    gettersAttributes(state) {
        return state.attributes;
    },
    gettersAttribute(state) {
        return state.attribute;
    },
    errorsAttribute(){
        return state.errors;
    },
    getAttributeLoad(){
        return state.load;
    },
};

const actions = {

    [ADD_ATTRIBUTE](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_ATTRIBUTES_ERROR, {});
            ApiService.post("/attribute/store", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_ATTRIBUTES_ERROR, response.data.errors);
                    }
                });
        });
    },

    [GET_ATTRIBUTES](context) {
        return new Promise((resolve, reject) => {
            context.commit(SET_ATTRIBUTE_LOAD, true);
            ApiService.get("/attributes")
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ATTRIBUTES, data);
                    context.commit(SET_ATTRIBUTE_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_ATTRIBUTES_ERROR, response.data.errors);
                    context.commit(SET_ATTRIBUTE_LOAD, false);
                });
        });
    },

    [GET_ATTRIBUTE](context, id) {
        context.commit(SET_ATTRIBUTE_LOAD, true);
        ApiService.get("/attribute", id)
            .then(({ data }) => {
                context.commit(SET_ATTRIBUTE, data);
                context.commit(SET_ATTRIBUTE_LOAD, false);
            })
            .catch(({ response }) => {
                context.commit(SET_ATTRIBUTES_ERROR, response.data.errors);
                context.commit(SET_ATTRIBUTE_LOAD, false);
            });
    },

    [UPDATE_ATTRIBUTE](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/attribute/update", data.id, data.attribute)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_ATTRIBUTES_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [DELETE_ATTRIBUTE](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/attribute/delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [DETACH_ATTRIBUTE_TO_PRODUCT](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("detach-attribute-in-product", data.product, {'attribute': data.attribute})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [ATTACH_ATTRIBUTE_TO_PRODUCT](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("attach-attribute-in-product", data.product, {'attribute': data.attribute})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [UPDATE_ATTRIBUTE_TO_PRODUCT](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("update-attribute-in-product", data.id, {
                    options: data.options,
                    image: data.image,
                    image_type: data.image_type,
                    images: data.images
                })
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [SORT_ATTRIBUTE_TO_PRODUCT](context, data) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.update("/attribute-in-product/sort", data.product, {attributes: data.attributes})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ATTRIBUTES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        context.commit(SET_ATTRIBUTES_ERROR, response.data.errors);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },


}


const mutations = {

    [SET_ATTRIBUTES_ERROR](state, error) {
        state.errors = error;
    },

    [SET_ATTRIBUTES](state, data) {
        state.attributes = data.attributes;

    },

    [SET_ATTRIBUTE](state, data) {
        state.attribute = data.attribute;
    },

    [SET_ATTRIBUTE_LOAD](state, load) {
        state.load = load;
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};

